export enum LogicFlowTraceLevelEnum {

    NONE,
    COUNTER,
    FULL,
}
